import { useMemo } from 'react'
import { deepMerge } from '@adalo/utils'

const PLAN_CARDS = {
  order: ['free', 'starter', 'pro', 'team', 'business'],
  cards: {
    free: {
      cardStyle: 'free',
      planType: 'free',
      displayName: 'Free',
      subtitle: 'Perfect for Exploring',
      prices: {
        monthly: 0,
        yearly: 0,
      },
      buttonAlias: 'Free',
      lowerPerks: [
        {
          text: `${process.env.REACT_APP_RECORD_LIMIT} Records`,
          subscript: '(per app)',
        },
        '1 App Editor',
      ],
      plusText: '',
      upperPerks: [
        'Database + Collections',
        'Unlimited Screens',
        'Unlimited Test Apps',
      ],
    },
    starter: {
      cardStyle: 'starter',
      planType: 'starter',
      planTypeMatch: 'starter2023', // Used to show user on legacy 'starter' as being on a 'current' plan in the upgrade
      displayName: 'Starter',
      subtitle: 'Launching Your MVP',
      prices: {
        monthly: 45,
        yearly: 36,
      },
      buttonAlias: 'Starter',
      lowerPerks: ['1 Published App', '1 App Editor'],
      plusText: 'All Free Features',
      upperPerks: ['Custom Fonts', 'Custom Domain'],
    },
    pro: {
      cardStyle: 'pro',
      planType: 'professional',
      displayName: 'Professional',
      subtitle: 'Growing Your Audience',
      prices: {
        monthly: 65,
        yearly: 52,
      },
      buttonAlias: 'Pro',
      lowerPerks: ['2 Published Apps', '5 App Editors'],
      plusText: 'All Starter Features',
      upperPerks: [
        'Collections API',
        'Design Versions',
        'Integrations',
        'Geolocation',
      ],
    },
    team: {
      cardStyle: 'team',
      planType: 'team',
      displayName: 'Team',
      subtitle: 'Expanding Your Business',
      prices: {
        monthly: 200,
        yearly: 160,
      },
      buttonAlias: 'Team',
      lowerPerks: ['5 Published Apps', '10 App Editors'],
      plusText: 'All Professional Features',
      upperPerks: ['Priority Support', 'Xano Integration'],
    },
    business: {
      cardStyle: 'business',
      planType: 'business2022',
      planTypeMatch: 'business2023',
      displayName: 'Business',
      subtitle: 'Powering Your Work',
      prices: {
        monthly: 250,
        yearly: 200,
      },
      buttonAlias: 'Business',
      lowerPerks: ['10 Published Apps', 'Unlimited App Editors'],
      plusText: 'All Team Features',
      upperPerks: [],
    },
  },
}

const PLAN_CARDS_STARTER_2023_PATCH = {
  cards: {
    starter: {
      planType: 'starter2023',
      planTypeMatch: 'starter',
      upperPerks: [
        'Web Publishing',
        'Native Mobile Publishing',
        'Custom Fonts',
        'Custom Domain',
      ],
    },
  },
}

const PLAN_CARDS_JUNE_2023_PATCH = {
  cards: {
    business: {
      planType: 'business2023',
      planTypeMatch: 'business2022',
      lowerPerks: ['10 Published Apps', 'Unlimited App Editors'],
    },
  },
}

const PLAN_CARDS_PROFESSIONAL_2023_PATCH = {
  cards: {
    pro: {
      cardStyle: 'pro',
      planType: 'professional2023',
      planTypeMatch: 'professional',
      upperPerks: ['Design Versions', 'Integrations', 'Geolocation'],
    },
    team: {
      upperPerks: ['Collections API', 'Priority Support', 'Xano Integration'],
    },
  },
}

const usePlanCards = currentPlanType => {
  const planCards = useMemo(() => {
    let mergedPlanCards = { ...PLAN_CARDS }

    mergedPlanCards = deepMerge(mergedPlanCards, PLAN_CARDS_STARTER_2023_PATCH)

    if (currentPlanType !== 'business2022') {
      mergedPlanCards = deepMerge(mergedPlanCards, PLAN_CARDS_JUNE_2023_PATCH)
    }

    if (currentPlanType !== 'professional') {
      mergedPlanCards = deepMerge(
        mergedPlanCards,
        PLAN_CARDS_PROFESSIONAL_2023_PATCH
      )
    }

    return mergedPlanCards
  }, [])

  return planCards
}

export default usePlanCards
